import { MarkerType } from '@vue-flow/core'

const COLUMN_COUNT = 5
const COLUMN_GAP = 260
const ROW_GAP = 164
const TURN_GAP = 96

export function buildRunVideoMatchGraph(turns, selectedNodeId) {
  const nodes = []
  const edges = []
  let turnOffsetY = 0

  for (const turn of turns) {
    const turnNodeId = `turn:${turn.context.turn_id}`
    const itemCount = turn.trace.steps.length + 1
    const rowCount = Math.ceil(itemCount / COLUMN_COUNT)
    nodes.push({
      id: turnNodeId,
      type: 'videoMatch',
      position: graphPosition(0, turnOffsetY),
      selected: turnNodeId === selectedNodeId,
      data: { kind: 'turn', turn, flow_direction: flowDirection(0) },
    })

    let previousNodeId = turnNodeId
    for (const [stepIndex, step] of turn.trace.steps.entries()) {
      const stepNodeId = `${turnNodeId}:step:${stepIndex}`
      nodes.push({
        id: stepNodeId,
        type: 'videoMatch',
        position: graphPosition(stepIndex + 1, turnOffsetY),
        selected: stepNodeId === selectedNodeId,
        data: {
          kind: 'step',
          turn,
          step,
          step_index: stepIndex,
          flow_direction: flowDirection(stepIndex + 1),
        },
      })
      edges.push({
        id: `${previousNodeId}->${stepNodeId}`,
        source: previousNodeId,
        target: stepNodeId,
        type: 'smoothstep',
        markerEnd: { type: MarkerType.ArrowClosed },
        class: `run-video-match-edge is-${edgeTone(step.status)}`,
      })
      previousNodeId = stepNodeId
    }
    turnOffsetY += rowCount * ROW_GAP + TURN_GAP
  }

  return { nodes, edges }
}

function flowDirection(index) {
  return Math.floor(index / COLUMN_COUNT) % 2 === 0 ? 'right' : 'left'
}

function graphPosition(index, offsetY) {
  const row = Math.floor(index / COLUMN_COUNT)
  const positionInRow = index % COLUMN_COUNT
  const column = row % 2 === 0
    ? positionInRow
    : COLUMN_COUNT - positionInRow - 1
  return { x: column * COLUMN_GAP, y: offsetY + row * ROW_GAP }
}

function edgeTone(status) {
  switch (status) {
    case 'passed':
    case 'ok':
    case 'available':
    case 'selected':
      return 'success'
    case 'error':
    case 'rejected':
    case 'needs_llm_selection':
    case 'stopped':
      return 'warning'
    case 'empty':
    case 'below_minimum':
    case 'miss':
    case 'not_recorded':
    case 'uncovered':
      return 'muted'
    default:
      return 'muted'
  }
}
